import React from 'react';
import { Link } from 'react-router-dom';

const actions = [
  {
    title: 'Add User',
    description: 'Create a new user account using an approved company domain and assign initial roles.',
    path: '/manage-user/add-user',
    buttonClass: 'btn-success',
  },
  {
    title: 'Assign Role',
    description: 'Select an existing user and update the authorities assigned to that account.',
    path: '/manage-user/assign-role',
    buttonClass: 'btn-primary',
  },
  {
    title: 'Update Information',
    description: 'Update leave balances and the manager assigned to an existing user.',
    path: '/manage-user/update-information',
    buttonClass: 'btn-warning',
  },
];

const ManageUserPage = () => (
  <div className="container py-4">
    <div className="text-center mb-4">
      <h1>Manage Users</h1>
      <p className="text-muted mb-0">Choose the user administration action you want to perform.</p>
    </div>

    <div className="row g-4">
      {actions.map((action) => (
        <div className="col-12 col-md-6 col-xl-4" key={action.path}>
          <div className="card h-100 shadow-sm">
            <div className="card-body d-flex flex-column">
              <h4 className="card-title">{action.title}</h4>
              <p className="card-text text-muted flex-grow-1">{action.description}</p>
              <Link className={`btn ${action.buttonClass}`} to={action.path}>
                Open {action.title}
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ManageUserPage;